document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('.product__media-list, .product__media');
  const prevButton = document.querySelector('.product-gallery-arrow--prev');
  const nextButton = document.querySelector('.product-gallery-arrow--next');

  if (!gallery || (!prevButton && !nextButton)) return;

  const slides = gallery.querySelectorAll('.grid__item');
  const slideCount = slides.length;
  if (slideCount === 0) return;

  let activeIndex = 0;

  const scrollToIndex = (index) => {
    activeIndex = (index + slideCount) % slideCount;
    gallery.scrollTo({
      left: activeIndex * gallery.offsetWidth,
      behavior: 'smooth',
    });
  };

  gallery.addEventListener('scroll', () => {
    const width = gallery.offsetWidth;
    if (!width) return;
    activeIndex = Math.round(gallery.scrollLeft / width);
  });

  if (prevButton) {
    prevButton.addEventListener('click', () => scrollToIndex(activeIndex - 1));
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => scrollToIndex(activeIndex + 1));
  }

  // Loop back to the first photo if the shopper keeps swiping past the last one.
  let touchStartX = 0;

  gallery.addEventListener(
    'touchstart',
    (event) => {
      touchStartX = event.touches[0].clientX;
    },
    { passive: true }
  );

  gallery.addEventListener('touchend', (event) => {
    const touchEndX = event.changedTouches[0].clientX;
    const swipedForward = touchStartX - touchEndX > 30;
    const width = gallery.offsetWidth;
    const atLastSlide = width && Math.round(gallery.scrollLeft / width) === slideCount - 1;

    if (swipedForward && atLastSlide) {
      scrollToIndex(0);
    }
  });
});
